import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiCheck } from 'react-icons/fi';
import Popup from '../Popup';
import '../../css/modal-seleccion.css';

/**
 * Modal para cambiar un valor de una lista cerrada (estado, departamento,
 * prioridad, técnico asignado…).
 *
 * Sustituye a los desplegables incrustados en la fila: con el modal cabe el
 * contexto (de qué ticket se trata, qué significa cada opción) y el cambio se
 * confirma de forma explícita, en vez de aplicarse al soltar el ratón.
 *
 * @param opciones  [{ valor, etiqueta, descripcion }]
 * @param valor     valor actual, para marcarlo y poder desactivar "Guardar"
 * @param onGuardar recibe el valor elegido; puede devolver una promesa
 */
const ModalSeleccion = ({ abierto, titulo, subtitulo, opciones, valor, onGuardar, onCerrar, textoGuardar }) => {
  const { t } = useTranslation();
  const [elegido, setElegido] = useState(valor);
  const [guardando, setGuardando] = useState(false);

  // Al reabrirlo para otra fila hay que partir del valor de esa fila
  useEffect(() => {
    if (abierto) {
      setElegido(valor);
      setGuardando(false);
    }
  }, [abierto, valor]);

  const guardar = async () => {
    if (guardando) return;
    // Sin cambios no hay nada que pedir al servidor: cerrar es la respuesta
    if (elegido === valor) {
      onCerrar();
      return;
    }
    setGuardando(true);
    try {
      await onGuardar(elegido);
      onCerrar();
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Popup
      open={abierto}
      title={titulo}
      onClose={onCerrar}
      onConfirm={guardar}
      showConfirm
      confirmText={guardando ? t('comun.guardando') : (textoGuardar || t('comun.guardar'))}
      cancelText={t('comun.cancelar')}
    >
      {subtitulo && <p className="modal-seleccion-subtitulo">{subtitulo}</p>}
      <div className="modal-seleccion-opciones" role="radiogroup" aria-label={titulo}>
        {opciones.map((opcion) => (
          <button
            key={opcion.valor}
            type="button"
            role="radio"
            aria-checked={elegido === opcion.valor}
            className={`modal-seleccion-opcion ${elegido === opcion.valor ? 'elegida' : ''}`}
            onClick={() => setElegido(opcion.valor)}
            disabled={guardando}
          >
            <span className="modal-seleccion-marca">{elegido === opcion.valor && <FiCheck />}</span>
            <span className="modal-seleccion-texto">
              {opcion.etiqueta}
              {opcion.descripcion && <small>{opcion.descripcion}</small>}
            </span>
            {opcion.valor === valor && <span className="modal-seleccion-actual">{t('comun.actual')}</span>}
          </button>
        ))}
      </div>
    </Popup>
  );
};

export default ModalSeleccion;
